export function scrollIntoView(elementId) {
  setTimeout(() => {
    window.scrollTo({
      behavior: "smooth",
      top:
        document.getElementById(elementId).getBoundingClientRect().top -
        document.body.getBoundingClientRect().top -
        100,
    });
  }, "500");
}

export const MIN_DATE = "1926-01-01";

export function minDateRule(v) {
  // empty values are left to the "required" rule, optional fields stay optional;
  // the browser accepts years with up to 6 digits, which odoo cannot store, so the
  // year must have exactly 4 digits (this also keeps the string comparison valid)
  return (
    !v ||
    (/^\d{4}-\d{2}-\d{2}$/.test(v) && v >= MIN_DATE) ||
    "Bitte ein gültiges Datum eingeben"
  );
}
